module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dialog'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ac61b15!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Auth.vue
// module id = 1252
// module chunks = 2